/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settingsnav_Usagemanagement2Inputs */

const zh_settingsnav_usagemanagement2 = /** @type {(inputs: Settingsnav_Usagemanagement2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用量记录`)
};

const en_settingsnav_usagemanagement2 = /** @type {(inputs: Settingsnav_Usagemanagement2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usage`)
};

const es_settingsnav_usagemanagement2 = /** @type {(inputs: Settingsnav_Usagemanagement2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uso`)
};

/**
* | output |
* | --- |
* | "Usage" |
*
* @param {Settingsnav_Usagemanagement2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const settingsnav_usagemanagement2 = /** @type {((inputs?: Settingsnav_Usagemanagement2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settingsnav_Usagemanagement2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_settingsnav_usagemanagement2(inputs)
	if (locale === "en") return en_settingsnav_usagemanagement2(inputs)
	return es_settingsnav_usagemanagement2(inputs)
});
export { settingsnav_usagemanagement2 as "settingsNav_usageManagement" }